
import {Component, Prop, Vue} from "vue-property-decorator";
import {stringify} from "@/auxillary/datafield.stringify";
import {translate} from "@/auxillary/translation";
import ReadonlyDataField from "@/models/ReadonlyDataField";


@Component({
  name: 'DisplayValueReadonly',
  components: {
  },
})
export default class DisplayValueReadonly extends Vue {

  @Prop({required: true})
  private dataField: ReadonlyDataField

  errorMessage: string = "";

  get displayName() {
    if (!this.dataField.displayName) return ""
    return this.dataField.displayName;
  }

  get isVisible() {
    return this.field.isVisible;
  }

  get value() {
    return this.dataField.values.value;
  }

  get unit() {
    // TODO: add tags with original field definition ids so that stringifier can format the value properly
    return this.dataField.definition.unit != undefined ? translate(this.dataField.definition.unit, "unit") : "";
  }

  get fieldDefinitionType() {
    return this.dataField.values.definitionType || "DisplayValue";
  }

  stringifyValue() {
    return stringify(this.field);
  }

  get field() {
    return this.dataField;
  }

}
